import { httpInstance } from '@/services/httpInstance';

const saveRootnessDocument = async (body) => {
  const endpoint = '/back-office/v1/rootness-document/';
  let res;
  await httpInstance.post(
    endpoint,
    body,
  ).then((dataResponse) => {
    res = dataResponse;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default saveRootnessDocument;
